import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/oddsCardCricket.css';
import {getText} from '../../../../../helpers/localization';
import OddsButtonCricket from "./oddsButtonCricket";

const mapStateToProps = (state, ownProps) => {
    return {
        openBetsSimpleList: state.vpp.openBetsSimpleList,
        selectedOddsType: state.vpp.selectedOddsType,
        systemLanguage: state.vpp.systemLanguage
    };
};

class OddsCardCricket extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            openBetsSimpleList: storeData.vpp.openBetsSimpleList,
            selectedOddsType: storeData.vpp.selectedOddsType,
            systemLanguage: storeData.vpp.systemLanguage
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                openBetsSimpleList: storeData.vpp.openBetsSimpleList,
                selectedOddsType: storeData.vpp.selectedOddsType,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    render() {
        let includeMarketLabel = this.props.includeMarketLabel === undefined ? true : this.props.includeMarketLabel;
        let text;
        let textBottom;
        if (includeMarketLabel) {
            if (this.props.homeTeam !== undefined && this.props.awayTeam !== undefined) {
                text = getText(this.props.market.selection, this.props.store, [this.props.homeTeam, this.props.awayTeam]);
            } else if (isNaN(this.props.market.selection)) {
                text = getText(this.props.market.selection, this.props.store);
            } else {
                text = this.props.market.selection;
            }

            if (this.props.multiDisplay) {
                let textSplit = text.split("/");
                text = textSplit[0];
                textBottom = getText('slash', this.props.store) + textSplit[1];
            }
        }
        return (
            <OddsButtonCricket active={true} market={this.props.market} store={this.props.store} circleSize={'large'}
                               customStyle={style.customButtonContainer}></OddsButtonCricket>
        );
    }

}

export default connect(mapStateToProps)(OddsCardCricket);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/cricket/components/oddsCardCricket.js